import { useHistory } from "react-router-dom";
import style from "./style.module.scss";

const titles = {
  nl: {
    purchases: "YOUTUBE",
    region: "FACEBOOK",
    lifestyle: "INSTAGRAM",
    news: "TWITTER",
  },
  fr: {
    purchases: "ACHETER",
    region: "REGION",
    lifestyle: "STYLE DE VIE",
    news: "INFO",
  },
};
const text = {
  nl: {
    title1: "MY MARBELLA, MY PROJECTS, MY LIFE",
    title2:
      "Volg mij op mijn sociale media, volg mijn projecten, mijn nieuwe leven, en vooral, geniet mee.",
  },
  fr: {
    title1: "Tout savoir en un coup d'œil!",
    title2: "Prêt pour le projet de vos rêves ? Ici, vous serez bien informé.",
  },
};
function PagesPart() {
  const lang = "nl";

  const pageData = [
    {
      image: "Images/infopages/common/pagespart/1.jpg",
      title: titles[lang]?.purchases,
      news: "news/purchases",
    },
    {
      image: "Images/infopages/common/pagespart/2.jpg",
      title: titles[lang]?.region,
      news: "news/region",
    },
    {
      image: "Images/infopages/common/pagespart/3.jpg",
      title: titles[lang]?.lifestyle,
      news: "news/lifestyle",
    },
    {
      image: "Images/infopages/common/pagespart/4.jpg",
      title: titles[lang]?.news,
      news: "news",
    },
  ];

  return (
    <div className={style.root}>
      <div className={style.titlePart}>
        <div>{text[lang]?.title1 || ""}</div>
        <div>{text[lang]?.title2 || ""}</div>
      </div>

      <div className={style.pagesGrid}>
        {pageData.map((data, i) => (
          <PageItem data={data} key={i} news={data.news} />
        ))}
      </div>
    </div>
  );
}

function PageItem({ data, number, news }) {
  const lang = "nl";
  const history = useHistory();

  const { image, title } = data;
  return (
    <div
      className={style.pageItem}
      onClick={(e) => history.push("/" + lang + "/" + news)}
      style={{ backgroundImage: `url("${image}")` }}
    >
      <div> {number ? "0" + number : ""} </div>
      <div> {title} </div>
    </div>
  );
}

export default PagesPart;
